<template lang="html">
  <div class="signup-success">
    <page-header />

    <div class="signup-success__image-wrapper">
      <img
        class="signup-success__image"
        src="@/assets/images/email.svg"
        alt=""
      />
    </div>

    <main class="signup-success__main">
      <h1 class="signup-success__title text-center">
        {{ $t("registrationPage.success.title") }}
      </h1>
      <p class="text text-center">
        {{ $t("registrationPage.success.subTitle") }}
      </p>
    </main>
  </div>
</template>

<script setup>
import PageHeader from "../components/ui/PageHeader"
</script>
